import { Controller } from 'stimulus'
import { useBusItem } from '../mixins/useBusItem.js'

export default class extends Controller {
  static values = {
    busItemId: String
  }

  connect() {
    useBusItem(this)
    setTimeout(this.loadUrlClipboard.bind(this), 0) // Timeout to wait for any dom changes in progress
  }

  loadUrlClipboard() {
    const loader = this.getBusItem('url-clipboard-loader')
    loader.urlParamsValue = this.inputsData
    loader.load()
  }

  // private
  get inputsData() {
    return $.deparam($(this.element.querySelectorAll('input')).serialize())
  }
}
